import { Circle } from "lucide-react";
import { cn } from "@/lib/utils";
import { memo } from "react";

interface TutorialRatingProps {
  rating: number;
}

export const TutorialRating = memo(function TutorialRating({ rating }: TutorialRatingProps) {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3].map((value) => (
        <Circle
          key={value}
          className={cn(
            "w-3 h-3",
            value <= rating
              ? "fill-warning stroke-warning"
              : "fill-muted stroke-muted"
          )}
        />
      ))}
    </div>
  );
});
